import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { APP_CONFIG } from '../../../tokens/app-config.token';
import { Environment } from '../../../../environments/environment.interface';

@Component({
  selector: 'dn-mobile-block',
  templateUrl: './mobile-block.component.html',
  styleUrl: './mobile-block.component.scss',
  standalone: false,
})
export class MobileBlockComponent {
  mobileNyze = `${this.appConfig.image_url}/empty-state-error-occured_1.svg`;
  iceberg = `${this.appConfig.image_url}/bottom-BG-mobile.png`;
  mobileGif = `${this.appConfig.image_url}/mobile-block.gif`;
  homepage = `${this.appConfig.WEBSITE}`;
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
  ) {}

  goToHomepage() {
    if (isPlatformBrowser(this.platformId)) {
      window.open(this.homepage, '_self');
    }
  }

  get img() {
    return `${this.appConfig.image_url}/datanyze-logo.png`;
  }
}
